import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {CircularProgress} from "@material-ui/core";
import Container from "@material-ui/core/Container";
import sectionbg from "../assets/images/section-bg.jpg";
import { HashLink as Link } from "react-router-hash-link";
import Scroll from "../components/Scroll";
import { db } from "../services/firebase";
import { Redirect, Route, Switch } from "react-router-dom";
import TeamRows from "../components/TeamRows";
import IndivRows from "../components/IndivRows";
import IndivDetail from "../components/IndivDetail";
import TeamDetail from "../components/TeamDetail";
import Scoreboard from "../components/Scoreboard";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
  },
  link: {},
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
  },
  flex: {
    display: "flex",
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(3),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    textAlign: "left",
  },
  element: {
    padding: theme.spacing(2),
    textAlign: "left",
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  backgroundSection: {
    backgroundImage: sectionbg,
  },
  anchortop: {
    display: "block",
    position: "relative",
    top: "-115px",
    visibility: "hidden",
  },
  anchor: {
    display: "block",
    position: "relative",
    top: "-90px",
    visibility: "hidden",
  },
}));

function createTeamData(
  name,
  id,
  wins,
  losses,
  pp20,
  power,
  ten,
  neg,
  pn,
  gn,
  tuh,
  pptuh,
  bh,
  bp,
  ppb
) {
  return { name, id, wins, losses, pp20, power, ten, neg, pn, gn, tuh, pptuh, bh, bp, ppb };
}

function createIndivData(
  name,
  id,
  team,
  teamid,
  gp,
  power,
  ten,
  neg,
  pn,
  gn,
  tuh,
  pptuh,
  points,
  pp20
) {
  return { name, id, team, teamid, gp, power, ten, neg, pn, gn, tuh, pptuh, points, pp20 };
}

export default function Results() {
  const classes = useStyles();
  const [data, setData] = useState({ rounds: {}, teams: {}, individuals: {} });
  const [done, setDone] = useState({ totRounds: 0, rounds: {}, teams: false, individuals: false});
  const setValue = useState(Date.now())[1];

  let finalists = ["40", "57", "38", "56"];

  let finalistRows = [{}, {}, {}, {}];
  let teamRows = [];
  Object.entries(data.teams).forEach(([k, v]) => {

        if (!finalists.includes(k)) {
          teamRows.push(createTeamData(
              v.name,
              k,
              v.wins,
              v.losses,
              v.tuh === 0
                  ? 0
                  : (
                      ((v.power * 15 + v.ten * 10 - v.neg * 5 + v.bp) / v.tuh) *
                      20
                  ).toFixed(2),
              v.power,
              v.ten,
              v.neg,
              v.neg === 0 ? "—" : (v.power / v.neg).toFixed(2),
              v.neg === 0 ? "—" : ((v.power + v.ten) / v.neg).toFixed(2),
              v.tuh,
              v.tuh === 0
                  ? 0
                  : ((v.power * 15 + v.ten * 10 - v.neg * 5 + v.bp) / v.tuh).toFixed(2),
              v.bh,
              v.bp,
              v.bh === 0 ? 0 : (v.bp / v.bh).toFixed(2)
          ));
        } else {
            finalistRows[finalists.indexOf(k)] = createTeamData(
                v.name,
                k,
                v.wins,
                v.losses,
                v.tuh === 0
                    ? 0
                    : (
                        ((v.power * 15 + v.ten * 10 - v.neg * 5 + v.bp) / v.tuh) *
                        20
                    ).toFixed(2),
                v.power,
                v.ten,
                v.neg,
                v.neg === 0 ? "—" : (v.power / v.neg).toFixed(2),
                v.neg === 0 ? "—" : ((v.power + v.ten) / v.neg).toFixed(2),
                v.tuh,
                v.tuh === 0
                    ? 0
                    : ((v.power * 15 + v.ten * 10 - v.neg * 5 + v.bp) / v.tuh).toFixed(2),
                v.bh,
                v.bp,
                v.bh === 0 ? 0 : (v.bp / v.bh).toFixed(2)
            )
        }
      }
  );
  teamRows.sort((a, b) => {
    let bPercentage = b.wins+b.losses===0 ? -1: b.wins/(b.wins + b.losses);
    let aPercentage = a.wins+a.losses===0 ? -1: a.wins/(a.wins + a.losses);
    if (bPercentage === aPercentage) {
      if (b.pp20 === a.pp20) {
        return a.name < b.name ? -1 : 1;
      }
      return b.pp20 - a.pp20;
    }
    if (b.losses === 0 && a.losses === 0) {
      return b.wins - a.wins;
    }
    if (b.wins === 0 && a.wins === 0) {
      if (a.losses === 0 && b.losses === 0) {
        return a.name < b.name ? -1 : 1;
      } else if (a.losses === 0) {
        return 1;
      } else if (b.losses === 0) {
        return -1;
      }
      return a.losses - b.losses;
    }
    return bPercentage - aPercentage;
  });

  let indivRows = Object.entries(data.individuals).map(([k, v]) =>
    createIndivData(
      v.name,
      k,
      v.team,
      v.teamId,
      (v.tuh / 20).toFixed(1),
      v.power,
      v.ten,
      v.neg,
      v.neg === 0 ? "—" : (v.power / v.neg).toFixed(2),
      v.neg === 0 ? "—" : ((v.power + v.ten) / v.neg).toFixed(2),
      v.tuh,
      v.tuh === 0
        ? 0
        : ((v.power * 15 + v.ten * 10 - v.neg * 5) / v.tuh).toFixed(2),
      v.power * 15 + v.ten * 10 - v.neg * 5,
      v.tuh === 0
        ? 0
        : (((v.power * 15 + v.ten * 10 - v.neg * 5) / v.tuh) * 20).toFixed(2)
    )
  );
  indivRows.sort((a, b) => {
    if (a.tuh === 0 && b.tuh === 0) {
      return a.name < b.name ? -1 : 1;
    } else if (a.tuh === 0) {
      return 1;
    } else if (b.tuh === 0) {
      return -1;
    }
    if (b.pp20 === a.pp20) {
      return a.name < b.name ? -1 : 1;
    }
    return b.pp20 - a.pp20;
  });

  const routes = [
    {
      path: "/results/standings",
      Component: TeamRows,
      props: { rows: teamRows, finalists: finalistRows},
    },
    {
      path: "/results/individuals",
      Component: IndivRows,
      props: { rows: indivRows },
    },
    { path: "/results/scoreboard", Component: Scoreboard, props: {rounds: data.rounds} },
    { path: "/results/teamdetail", Component: TeamDetail, props: {teams: data.teams, individuals: data.individuals} },
    {
      path: "/results/individualdetail",
      Component: IndivDetail,
      props: { individuals: data.individuals },
    },
  ];

  React.useEffect(() => {
    db.collection("stats/0/teams")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          data.teams[doc.id] = doc.data();
          if (Object.keys(data.teams).length === querySnapshot.docs.length) {
            setData(data);
            done.teams = true;
            setDone(done);
            setValue(Date.now());
          }
        });
      });
    db.collection("stats/0/individuals")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          data.individuals[doc.id] = doc.data();
          if (
            Object.keys(data.individuals).length === querySnapshot.docs.length
          ) {
            setData(data);
            done.individuals = true;
            setDone(done);
            setValue(Date.now());
          }
        });
      });
    db.collection("stats/0/rounds")
        .get()
        .then((querySnapshot) => {
          done.totRounds = querySnapshot.docs.length;
          setDone(done);
          querySnapshot.forEach((doc) => {
            data.rounds[doc.id] = {};
            db.collection(`stats/0/rounds/${doc.id}/rooms`)
                .get()
                .then((roomSnapshot) => {
                  if (roomSnapshot.docs.length === 0) {
                    done.rounds[doc.id] = true;
                    setDone(done);
                    setValue(Date.now());
                  }
                  roomSnapshot.forEach((room) => {
                    data.rounds[doc.id][room.id] = room.data();
                    if (Object.keys(data.rounds[doc.id]).length === roomSnapshot.docs.length) {
                      setData(data);
                      done.rounds[doc.id] = true;
                      setDone(done);
                      setValue(Date.now());
                    }
                  })
                });
          });
        });
  }, [data, done, setValue]);

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Scroll showBelow={250} />
      <div className={classes.element}>
        <div className={classes.anchortop} id="nhsst" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Typography variant="h4" component="h2" gutterBottom>
            <b>National High School Science Tournament 2021 — Live Stats</b>
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" component="h2" gutterBottom>
              <Link className="about" to="/results/standings">
                Standings
              </Link>
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <Link className="about" to="/results/individuals">
                Individuals
              </Link>
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <Link className="about" to="/results/scoreboard">
                Scoreboard
              </Link>
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <Link className="about" to="/results/teamdetail">
                Team Detail
              </Link>
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <Link className="about" to="/results/individualdetail">
                Individual Detail
              </Link>
            </Typography>
          </div>
        </div>
      </div>
      {Object.keys(done.rounds).length === done.totRounds && done.teams && done.individuals ?
          <Switch>
            {routes.map(({ path, Component, props }) => (
                <Route key={path} exact path={path}>
                  <Component {...props} />
                </Route>
            ))}
            <Redirect to="/results/standings" />
          </Switch> : <CircularProgress />
      }
    </Container>
  );
}
